<template>
  <div class='scoreProgressBar'>
    <div class='progress_body' :style='`backgroundColor:${colorConfig.activeColor}30`'>
      <el-progress type="circle"
                   :percentage="colorConfig.percent"
                   :stroke-width="10"
                   :color="colorConfig.activeColor"
                   :format="format"></el-progress>
    </div>
    <div class="rules">
      <div class="rule_item"
            v-for="item in progressBarConfig.tips">
        <div class="tag"
              :style="`backgroundColor: ${item.color}`">
        </div>
        <span>{{item.label}}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'scoreProgressBar',
  props: {
    progressBarConfig: {
      type: Object,
    },
    num: {
      type: Number,
    }
  },
  computed: {
    colorConfig () {
      let { num } = this
      return this.progressBarConfig.setConfig(num)
    }
  },
  methods: {
    format() {
      return this.colorConfig.text
    }
  }
}
</script>

<style lang='scss' scoped>
.scoreProgressBar {
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
  width: 100%;

	.progress_body {
    position: relative;
    display: flex;
    width: 120px;
    height: 120px;
    background-color: #F7C1B1;
    border-radius: 50%;
		::v-deep .el-progress {
      position: absolute;
      top: -2px;
      left: -2px;

			path:first-child {
				stroke: #ffffff;
			}
		}
	}

	.rules {
		display: flex;
		margin-top: 20px;
    width: 100%;
    justify-content: center;

		.rule_item {
      // flex: 1;
      // width: 0;
			display: flex;
			justify-content: center;
			align-items: center;
			margin: 0 10px;
			font-size: 12px;

			.tag {
				width: 20px;
				height: 20px;
				background-color: red;
				margin-right: 10px;
			}
		}
	}
}
</style>
